import { css } from '@emotion/css';
import { m, MotifComponent, ZIndex } from '@snapchat/snap-design-system-marketing';

export const persistentCtaContainerCss = css`
  background-color: ${m('--bg-color')};
  bottom: 0;
  opacity: 0;
  padding: ${m('--spacing-xs')};
  position: sticky;
  transition: opacity 300ms ease-in-out, visibility 0s 300ms;
  visibility: hidden;
  z-index: ${ZIndex.MOBILE_CTA};

  .${MotifComponent.BUTTON}.${MotifComponent.BUTTON} {
    align-items: center;
    border-radius: ${m('--border-radius-s')};
    display: flex;
    justify-content: center;
    min-height: 54px; /* Custom for this feature. */
  }
`;

export const persistentCtaVisibleCss = css`
  opacity: 1;
  transition: opacity 300ms ease-in-out, visibility 0s 0s;
  visibility: visible;
`;
